(function(angular) {
    angular.module('bizPartEngage').service('core.event.statistics.service', eventStatisticsService);

    eventStatisticsService.$inject = ["$http"];

    function eventStatisticsService($http) {
        this.GetAllEventStatisticsForUser = function(page, limit) {
            return $http.get(siteRootPath + 'api/eventstatistics/GetAllEventStatisticsForUser?' + $.param({page: page, limit: limit}));
        }
    }
    //GetAllEventStatisticsForUser
})(window.angular);
